import { useQuery } from "react-query";
import { axios } from "../../lib/axios";
import { onError } from "./onError"

export function useOrgHcnQuery({ onSuccess, orgId }) {

    const fetch = () => {
        return axios.get(`/organization/${orgId}/hcn-authority`);
    };
    const query = useQuery(
        ["hcn", orgId],
        () => fetch(),
        {
        enabled: !!orgId,
        select: (data) => data?.data,
        onSuccess,
        onError,
        }
    );

    return { ...query };
}
